import sp1 from "../assets/icon/sp1.png";
import ng from "../assets/icon/NG.png";
import gh from "../assets/icon/gh.png";
import uk from "../assets/icon/uk.png";
import us from "../assets/icon/am.png";
import can from "../assets/icon//can.png";
import sp2 from "../assets/icon/sp2.png";
import ad1 from "../assets/icon/ad1.png";
// import ad2 from "../assets/icon/ad2.png";
import ad3 from "../assets/icon/ad3.png";
// import ad4 from "../assets/icon/web3.jpg"
import ip1 from "../assets/icon/ip1.png";
import ip2 from "../assets/icon/ip2.png";
import avatar1 from "../assets/successImage1.png";
import avatar2 from "../assets/successImage2.png";
import avatar3 from "../assets/successImage3.png";
import avatar4 from "../assets/successImage4.png";
import avatar5 from "../assets/successImage5.png";
import avatar6 from "../assets/successImage6.png";
import lk1 from "../assets/icon/lekkiImgs/lk1.png";
import lk2 from "../assets/icon/lekkiImgs/lk2.png";
import lk3 from "../assets/icon/lekkiImgs/lk3.png";
import lk4 from "../assets/icon/lekkiImgs/lk4.png";
import mainland1 from "../assets/icon/mainlandImgs/mainland1.png";
import abj1 from "../assets/icon/abujaImgs/abj1.png";
import berger1 from "../assets/icon/bergerImgs/berger1.png";
import ib1 from "../assets/icon/ibadanImgs/ib1.png";
import microvest from "../assets/icon/microvest.svg";
import elite from "../assets/icon/ELITE DIGEST-01 1.png";
import microsoft from "../assets/icon/microsoft.svg";
import ulo from "../assets/icon/ulospaces.svg";
import perxels from "../assets/icon/perxels.svg";
import ibrahim from "../assets/Alumni/Ibrahim.png";
import jennifer from "../assets/Alumni/Jennifer.png";
import damola from "../assets/Alumni/Damola.png";
import funmilola from "../assets/Alumni/Funmilayo.png";
import abiola from "../assets/Alumni/Abiola.png";
import akeredolu from "../assets/Alumni/Akeredolu.png";
import matthew from "../assets/Alumni/Matthew.png";
import precious from "../assets/Alumni/Precious.png";
import adeoluwa from "../assets/Alumni/Adeoluwa.png";
import apalowo from "../assets/Alumni/Apalowo.png";
import speaker1 from "../assets/icon/careerfair/speaker1.png";
import speaker2 from "../assets/icon/careerfair/speaker2.png";
import speaker3 from "../assets/icon/careerfair/speaker3.png";
import speaker4 from "../assets/icon/careerfair/speaker4.png";
import newsImg1 from "../assets/icon/about/newsImg1.png";
import newsImg2 from "../assets/icon/about/newsImg2.png";
import newsImg3 from "../assets/icon/about/newsImg3.png";
import newsImg4 from "../assets/icon/about/newImg4.jpg";

export const standardPrograms = [
  {
    img: sp1,
    headText: "Online Training",
    subText: "For Newbies in Product Management ",
    link: "/programs",
  },
  {
    img: sp2,
    headText: "Hybrid Training",
    subText: "For Newbies in Product Management ",
    link: "/programs",
  },
];

export const advancedPrograms = [
  {
    img: ad1,
    headText: "Technical Product Management",
    subText: "For Experienced Product Managers",
    link: "/technicalpm",
  },

  {
    img: ad3,
    headText: "Agentic AI Program",
    subText: "For Experienced Product Managers",
    linkText: "",
    link: "/agenticai",
  },
  // {
  //   img: ad2,
  //   headText: "Growth Product Management",
  //   subText: "For Experienced Product Managers",
  //   link: "/growthpm",
  // },
  // {
  //   img: ad4,
  //   headText: "Web 3 Product Management",
  //   subText: "For Product Leaders",
  //   linkText: "COMING SOON!!!",
  //   link : "/aipmp"
  // },
];

export const internationalPrograms = [
  {
    img: ip1,
    headText: "International Program",
    subText: "For Nigerians in diaspora",
    link: "/international",
    linkText: "COMING SOON!!!",
  },
  {
    img: ip2,
    headText: "Kenya Center",
    subText: "For Newbies in Kenya",
    link: "/kenya",
    linkText: "COMING SOON!!!",
  },
];

export const SuccessData = [
  {
    avatar: avatar1,
    name: "Raphiu Silas",
    role: "Product Engineer",
    notes:
      "Enoverlab is an ideal school for anybody who wants to learn product management. Their syllabus is profound and their mentors are aweome. I got a job after my training Thank you!",
    flag: ng,
  },
  {
    avatar: avatar2,
    name: "Kofe Anan",
    role: "Ceo Afrofusion",
    notes:
      "Enoverlab  is a super encouraging, friendly group of Product Managers  at all stages of their career. There is always  something to learn from everyone. which is super awesome",
    flag: gh,
  },
  {
    avatar: avatar3,
    name: "Sandra Tabansi",
    role: "Ceo Fruittylife",
    notes:
      "Enoverlab  is a an awesome group of productmanagers who  are  striving to give out their best in their careers",
    flag: can,
  },
  {
    avatar: avatar4,
    name: "Samuel Adekoya",
    role: "Bank Manager",
    notes:
      "The product management course at Enoverlab is very detailed and each class was an   interesting experience for me. Coming from a field that is not tech related. I was able to easily understand the role of a product manager.",
    flag: us,
  },
  {
    avatar: avatar5,
    name: "Joy Alem",
    role: "Student",
    notes:
      "I like how structured and practical the classes have been.I have been able to get grounded knowledge on product management",
    flag: ng,
  },
  {
    avatar: avatar6,
    name: "Tommy Rowland",
    role: "Pilot",
    notes:
      "“Looking to get the best value for your money then Enoverlab is the best place to begin, dontoverthink it just got for it",
    flag: uk,
  },
];

export const programLocale1 = [lk1, lk2, lk3, lk4];
export const programLocale2 = [mainland1, lk2, lk3, lk4];
export const programLocale3 = [abj1, lk2, lk3, lk4];
export const programLocale4 = [berger1, lk2, lk3, lk4];
export const programLocale5 = [ib1, lk2, lk3, lk4];

export const onlineProgram = [
  "This training is for anyone who wants to become a full professional Product Manager",
  "It covers everything you need to learn in product management",
  "It is a live online instructor-led training",
  "12 weeks intensive training and mentorship",
  "Lifetime access to product management resources",
  "Lifetime access to our robust community of Product Managers",
  "You will get an international certificate accredited by American Council of Training and Development (ACTD) at the end of the training",
  "6 hours class on “How to get a Product Manager job” including CV review, LinkedIn Profile Optimization, Interview Prep, websites to apply for jobs, assessment guide, etc",
];

export const selfPacedProgram = [
  "Learn everything in product management at your own pace, in your own schedule, and at your own time",
  "Lifetime access to product management resources",
  "Lifetime access to our robust community of Product Managers",
  "You will get a Certificate of Completion at the end of the training ",
  "Opportunity to meet other learners from across the globe",
  "With the knowledge from this training, you can become an Associate or Junior Product Manager in any organisation across the globe",
];

export const associateProgram = [
  "This training is for undergraduates, graduates, youth corpers, and anyone who is still trying to decide if product management is the right career for them ",
  "The training covers the fundamentals of product management",
  "It is a live online instructor-led training",
  "Lifetime access to product management resources",
  "Lifetime access to our robust community of Product Managers",
  "You will get a Certificate of Completion at the end of the training ",
  "Opportunity to meet other learners from across the globe",
  "With the knowledge from this training, you can become an Associate or Junior Product Manager in any organisation across the globe",
];

export const executiveProgram = [
  "One-on-one coaching ONLINE for 4 weeks",
  "Flexible class time schedule",
  "Close support and guidance till you land a Product Manager role",
  "Access to international job platforms",
  "International certification accredited by the American Council of Training and Development (ACTD)",
  "Lifetime access to Product management resources",
  "You get The Blood Money in Tech ebook for FREE",
  "Personal recommendation from our CEO for job offers and VISA application ",
];
export const businessProgram = [
  "Product Thinking",
  "6 pillars of product thinking",
  "Solving problems for your customers",
  "Defining your target users",
  "Crafting a product vision",
  "Defining your business objectives",
  "Creating a product/service",
  "Developing a business strategy",
  "Practical application of product thinking",
  "And so much more...",
];

export const HybridProgram = [
  "12 weeks Intensive training and mentorship Hybrid",
  "A small class for only 10 persons",
  "International certification accredited by the American Council of Training and Development (ACTD)",
  "Lifetime access to Product management resources",
  "Access to a supportive community of over 1,000 product managers across the globe",
  "Opportunity to physically connect with incredible people on the same Product Manager journey",
  "6 hours class on “How to get a Product Manager job” including CV review, LinkedIn Profile Optimization, Interview Prep, websites to apply for jobs, assessment guide, etc",
  "Enoverlab branded flask, notepad, stickers, and personal note from the CEO ",
];

export const PMPProgram = [
  "Introduction to Product Management",
  "Key Project Management Terminologies",
  "Stakeholder, Team Performance & Planning Performance Domain",
  "Project Lifecycle",
  "Software Development Lifecycle (SDLC)",
  "Agile vs Waterfall in Tech Projects",
  "Scrum Basics: Sprints, Sprint Planning, Daily Scrum, Sprint Review, Sprint Retrospective, Backlog, Roles",
  "Risk, Quality & Communication Management",
  "Project Closure & Documentation",
  "Career Coaching; How to get a Project Manager Job",
];

export const HybridProgramWeekday = [
  "7 weeks Intensive training and mentorship Hybrid",
  "A small class for only 10 persons",
  "International certification accredited by the American Council of Training and Development (ACTD)",
  "Lifetime access to Product management resources",
  "Access to a supportive community of over 1,000 product managers across the globe",
  "Opportunity to physically connect with incredible people on the same Product Manager journey",
  "6 hours class on “How to get a Product Manager job” including CV review, LinkedIn Profile Optimization, Interview Prep, websites to apply for jobs, assessment guide, etc",
  "Enoverlab branded flask, notepad, stickers, and personal note from the CEO ",
];

export const privateCoaching = [
  "This training is for busy people, senior level professionals, and Nigerians in diaspora",
  "It covers everything you need to learn in product management",
  `One-on-One Coaching Online`,
  "⁠Guaranteed Job Placement",
  "Personalised career coaching and guidance",
  "Lifetime access to product management resources",
  "Lifetime access to our robust community of Product Managers",
  "International certificate accredited by American Council of Training and Development (ACTD) at the end of the training",
  "CV review and optimisation",
  "Interview prep and assessment guide",
  "High Priority ⁠⁠Job recommendations when available",
];

export const AiProgram = [
  "Key definitions - introduction to AI and different forms of AI ",
  "Developing an Analytical mind  ",
  "Research, Data gathering and Management ",
  "AI Product Development Lifecycle ",
  "AI Product Strategy ",
  "Measuring success of AI Products",
  "Data/AI Governance ",
  "Machine Learning Operations (MLOPs): Implementing MLOPs for delivery of AI Products",
  "Dissection Case Studies of AI products",
];

export const GrowthProgram = [
  "Introduction to Product Growth",
  "Different types of Growth",
  "Understanding Growth Terms - Gamification, Time-to-Value, Economies of Scale, Network Effects, Personalisation, Habit Forming, etc",
  "Achieving Product Market Fit (PMF)",
  "Growing from product market fit",
  " Product Metrics AARRR (Acquisition, Activation, Retention, Referral, Revenue)",
  "Tracking Data with Amplitude & Mixpanel",
  "Rapid Testing & Experimentation; A/B Testing & Usability Testing",
  "Product Strategy Product Led Growth",
  "Collaborating with the Marketing Team",
  "Creating & Implementing Growth Plans",
  "Analysing Different Growth Strategies of Major Tech Companies",
];

export const TechnicalProgram = [
  "Introduction to Technical Product Management",
  "Fundamentals of APIs",
  "API Management and Strategy",
  "Building Effective Support Systems",
  "Support Tools and Metrics",
  "Using Postman and Azure to test APIs",
  "Integration Approaches and Patterns",
  "Integration Tools and Platforms",
  "Deployment and deployment environments",
];

export const FaqContent = [
  {
    questionTitle: "1.  What exactly is Product Management?",
    questionAnswer:
      "Product Management is the process of building and managing products to solve problems and deliver solutions to specific customers/users and drive business value for an organization. Even though product management is popular in tech, it is not limited to tech. The principles and ideas in product management can be applied in any other industry.",
  },
  {
    questionTitle:
      "2. Can I still take the training without any idea on tech or product management?",
    questionAnswer:
      "Yes, you can take the training regardless of your background. Over 80% of people who have taken our training have no tech background and more than 60% of them are currently working in different product manager roles for companies across the globe.",
  },
  {
    questionTitle: "3. Is the training beginner friendly?",
    questionAnswer:
      "Yes, the training is beginner friendly. Our Instructors will literally hold you by the hand and guide you through the learning process. In addition, our training is practical driven with class tasks, assignments, group work, and capstone projects to help you learn better by doing.",
  },
  {
    questionTitle: "4. Do I get a certificate at the end of the training?",
    questionAnswer:
      "Yes, you will be awarded the Enoverlab Product Management Certificate accredited by the American Council of Training and Development which is globally recognised.",
  },
  {
    questionTitle: "5. What are the benefits of becoming a Product Manager?",
    questionAnswer:
      "By becoming a Product Manager, you will build skills that will make you very valuable to any organization. You can work fully remote or hybrid for any company in the world, create a product that solves problems, earn a great salary for your effort, and make the lives of people better through the product solutions you create.",
  },
];

export const AiFaqContent = [
  {
    questionTitle: "1.  What are the prerequisites for this program? ",
    questionAnswer:
      "This program is designed for product managers with a basic understanding of product development. No prior knowledge of AI is required.",
  },
  {
    questionTitle: "2.  Will I learn how to code AI models? ",
    questionAnswer:
      "This program focuses on the product management aspects of AI, not on coding the models themselves. However, we will discuss the different types of AI models and the development process.",
  },
  {
    questionTitle:
      "3.  Is this program relevant for non-technical product managers?",
    questionAnswer:
      "Absolutely! The program equips product managers with the necessary knowledge to lead AI product development teams.",
  },
  {
    questionTitle: "4. What types of AI products will we be covering?",
    questionAnswer:
      "We will explore a variety of AI products across different industries, showcasing the diverse applications of this technology. ",
  },
  {
    questionTitle: "5. How will the case study be conducted? ",
    questionAnswer:
      "The case study will be a group activity where you'll analyse a real-world AI product, identify its core elements, and discuss its development process and potential future directions.",
  },
  {
    questionTitle: "6. What should I expect after this program? ",
    questionAnswer:
      "By the end of the program, participants will be future-proofed with the knowledge to build innovative AI products that make a positive impact and derive value to customers and organisations.",
  },
];

export const partners = [microvest, elite, microsoft, ulo, perxels];

export const benefits1 = [
  {
    title: "Data Driven Insights",
    details:
      "Product managers can leverage these insights to make informed decisions and prioritize features based on data rather than intuition",
  },
  {
    title: "Personalization",
    details:
      "Product managers can use AI-powered recommendation engines to deliver tailored content and recommendations, increasing user engagement and satisfaction.",
  },
  {
    title: "Automation",
    details:
      "Automation can streamline workflows, reduce manual errors, and increase efficiency, ultimately accelerating product development and time-to-market.",
  },
];

export const benefit2 = [
  {
    title: "Predictive Analytics",
    details:
      "Predictive analytics can help identify potential issues before they arise, enabling proactive decision-making and risk mitigation",
  },
  {
    title: "Optimized Resource Allocation",
    details:
      "Product managers can use AI-driven insights to allocate resources more effectively, ensuring that projects are delivered on time and within budget.",
  },
  {
    title: "Continuous Improvement",
    details:
      "By continuously monitoring user feedback and behavior, product managers can identify areas for improvement and implement changes to enhance the user experience.",
  },
];

export const alumni = [
  ibrahim,
  jennifer,
  damola,
  funmilola,
  abiola,
  akeredolu,
  matthew,
  precious,
  adeoluwa,
  apalowo,
];

export const accessData = [
  "Intensive training",
  "Project based learning",
  "Global Certificate",
];

export const pmpAccessData = [
  "Intensive training",
  "Online instructor led",
  "Project based learning",
  "Global Certificate",
];

export const executiveData = [
  "Indepth Coaching",
  "Personalised learning",
  "Flexible Schedule",
  "Global Certificate",
];

export const countries = [
  { city: "Lagos", state: "Lagos", country: "Nigeria" },
  { city: "Ikeja", state: "Lagos", country: "Nigeria" },
  { city: "Ikorodu", state: "Lagos", country: "Nigeria" },
  { city: "Badagry", state: "Lagos", country: "Nigeria" },
  { city: "Epe", state: "Lagos", country: "Nigeria" },
  { city: "Ibadan", state: "Oyo", country: "Nigeria" },
  { city: "Ogbomosho", state: "Oyo", country: "Nigeria" },
  { city: "Oyo", state: "Oyo", country: "Nigeria" },
  { city: "Iseyin", state: "Oyo", country: "Nigeria" },
  { city: "Eruwa", state: "Oyo", country: "Nigeria" },
  { city: "Abeokuta", state: "Ogun", country: "Nigeria" },
  { city: "Ijebu Ode", state: "Ogun", country: "Nigeria" },
  { city: "Sagamu", state: "Ogun", country: "Nigeria" },
  { city: "Owode", state: "Ogun", country: "Nigeria" },
  { city: "Akure", state: "Ondo", country: "Nigeria" },
  { city: "Ondo City", state: "Ondo", country: "Nigeria" },
  { city: "Owo", state: "Ondo", country: "Nigeria" },
  { city: "Ikare", state: "Ondo", country: "Nigeria" },
  { city: "Ife", state: "Osun", country: "Nigeria" },
  { city: "Osogbo", state: "Osun", country: "Nigeria" },
  { city: "Ilesa", state: "Osun", country: "Nigeria" },
  { city: "Ede", state: "Osun", country: "Nigeria" },
  { city: "Ado-Ekiti", state: "Ekiti", country: "Nigeria" },
  { city: "Ikere-Ekiti", state: "Ekiti", country: "Nigeria" },
  { city: "Effon-Alaiye", state: "Ekiti", country: "Nigeria" },
  { city: "Aba", state: "Abia", country: "Nigeria" },
  { city: "Umuahia", state: "Abia", country: "Nigeria" },
  { city: "Ohafia", state: "Abia", country: "Nigeria" },
  { city: "Onitsha", state: "Anambra", country: "Nigeria" },
  { city: "Awka", state: "Anambra", country: "Nigeria" },
  { city: "Nnewi", state: "Anambra", country: "Nigeria" },
  { city: "Abakaliki", state: "Ebonyi", country: "Nigeria" },
  { city: "Afikpo", state: "Ebonyi", country: "Nigeria" },
  { city: "Enugu", state: "Enugu", country: "Nigeria" },
  { city: "Nsukka", state: "Enugu", country: "Nigeria" },
  { city: "Owerri", state: "Imo", country: "Nigeria" },
  { city: "Orlu", state: "Imo", country: "Nigeria" },
  { city: "Okigwe", state: "Imo", country: "Nigeria" },
  { city: "Kano", state: "Kano", country: "Nigeria" },
  { city: "Kaduna", state: "Kaduna", country: "Nigeria" },
  { city: "Zaria", state: "Kaduna", country: "Nigeria" },
  { city: "Sokoto", state: "Sokoto", country: "Nigeria" },
  { city: "Katsina", state: "Katsina", country: "Nigeria" },
  { city: "Gusau", state: "Zamfara", country: "Nigeria" },
  { city: "Birnin Kebbi", state: "Kebbi", country: "Nigeria" },
  { city: "Dutse", state: "Jigawa", country: "Nigeria" },
  { city: "Hadejia", state: "Jigawa", country: "Nigeria" },
  { city: "Kazaure", state: "Jigawa", country: "Nigeria" },
  { city: "Daura", state: "Katsina", country: "Nigeria" },
  { city: "Funtua", state: "Katsina", country: "Nigeria" },
  { city: "Argungu", state: "Kebbi", country: "Nigeria" },
  { city: "Yelwa", state: "Kebbi", country: "Nigeria" },
  { city: "Garki", state: "Jigawa", country: "Nigeria" },
  { city: "Kaura Namoda", state: "Zamfara", country: "Nigeria" },
  { city: "Gummi", state: "Zamfara", country: "Nigeria" },
  { city: "Binji", state: "Sokoto", country: "Nigeria" },
  { city: "Tangaza", state: "Sokoto", country: "Nigeria" },
  { city: "Maiduguri", state: "Borno", country: "Nigeria" },
  { city: "Bauchi", state: "Bauchi", country: "Nigeria" },
  { city: "Yola", state: "Adamawa", country: "Nigeria" },
  { city: "Mubi", state: "Adamawa", country: "Nigeria" },
  { city: "Gombe", state: "Gombe", country: "Nigeria" },
  { city: "Jimeta", state: "Adamawa", country: "Nigeria" },
  { city: "Potiskum", state: "Yobe", country: "Nigeria" },
  { city: "Jalingo", state: "Taraba", country: "Nigeria" },
  { city: "Gashua", state: "Yobe", country: "Nigeria" },
  { city: "Bama", state: "Borno", country: "Nigeria" },
  { city: "Numan", state: "Adamawa", country: "Nigeria" },
  { city: "Takum", state: "Taraba", country: "Nigeria" },
  { city: "Wukari", state: "Taraba", country: "Nigeria" },
  { city: "Ganye", state: "Adamawa", country: "Nigeria" },
  { city: "Michika", state: "Adamawa", country: "Nigeria" },
  { city: "Biu", state: "Borno", country: "Nigeria" },
  { city: "Dikwa", state: "Borno", country: "Nigeria" },
  { city: "Geidam", state: "Yobe", country: "Nigeria" },
  { city: "Damaturu", state: "Yobe", country: "Nigeria" },
  { city: "Gashaka", state: "Taraba", country: "Nigeria" },
  { city: "Bangkok", state: "Bangkok", country: "Thailand" },
  { city: "Paris", state: "Île-de-France", country: "France" },
  { city: "London", state: "England", country: "United Kingdom" },
  { city: "Dubai", state: "Dubai", country: "United Arab Emirates" },
  { city: "Kuala Lumpur", state: "Federal Territory", country: "Malaysia" },
  { city: "Singapore", state: "Central Region", country: "Singapore" },
  { city: "New York", state: "New York", country: "United States" },
  { city: "Istanbul", state: "Istanbul", country: "Turkey" },
  { city: "Tokyo", state: "Tokyo", country: "Japan" },
  { city: "Seoul", state: "Seoul", country: "South Korea" },
  { city: "Osaka", state: "Osaka", country: "Japan" },
  { city: "Seattle", state: "Washington", country: "United States" },
  { city: "Mumbai", state: "Maharashtra", country: "India" },
  { city: "Las Vegas", state: "Nevada", country: "United States" },
  { city: "Los Angeles", state: "California", country: "United States" },
  { city: "Chicago", state: "Illinois", country: "United States" },
  {
    city: "Washington D.C.",
    state: "District of Columbia",
    country: "United States",
  },
];

export const countryCodes = [
  { country: "Nigeria", code: "234", iso: "NG" },
  { country: "Afghanistan", code: "93", iso: "AF" },
  { country: "Albania", code: "355", iso: "AL" },
  { country: "Algeria", code: "213", iso: "DZ" },
  { country: "American Samoa", code: "1-684", iso: "AS" },
  { country: "Andorra", code: "376", iso: "AD" },
  { country: "Angola", code: "244", iso: "AO" },
  { country: "Anguilla", code: "1-264", iso: "AI" },
  { country: "Antarctica", code: "672", iso: "AQ" },
  { country: "Antigua and Barbuda", code: "1-268", iso: "AG" },
  { country: "Argentina", code: "54", iso: "AR" },
  { country: "Armenia", code: "374", iso: "AM" },
  { country: "Aruba", code: "297", iso: "AW" },
  { country: "Australia", code: "61", iso: "AU" },
  { country: "Austria", code: "43", iso: "AT" },
  { country: "Azerbaijan", code: "994", iso: "AZ" },
  { country: "Bahamas", code: "1-242", iso: "BS" },
  { country: "Bahrain", code: "973", iso: "BH" },
  { country: "Bangladesh", code: "880", iso: "BD" },
  { country: "Barbados", code: "1-246", iso: "BB" },
  { country: "Belarus", code: "375", iso: "BY" },
  { country: "Belgium", code: "32", iso: "BE" },
  { country: "Belize", code: "501", iso: "BZ" },
  { country: "Benin", code: "229", iso: "BJ" },
  { country: "Bermuda", code: "1-441", iso: "BM" },
  { country: "Bhutan", code: "975", iso: "BT" },
  { country: "Bolivia", code: "591", iso: "BO" },
  { country: "Bosnia and Herzegovina", code: "387", iso: "BA" },
  { country: "Botswana", code: "267", iso: "BW" },
  { country: "Brazil", code: "55", iso: "BR" },
  { country: "British Indian Ocean Territory", code: "246", iso: "IO" },
  { country: "British Virgin Islands", code: "1-284", iso: "VG" },
  { country: "Brunei", code: "673", iso: "BN" },
  { country: "Bulgaria", code: "359", iso: "BG" },
  { country: "Burkina Faso", code: "226", iso: "BF" },
  { country: "Burundi", code: "257", iso: "BI" },
  { country: "Cambodia", code: "855", iso: "KH" },
  { country: "Cameroon", code: "237", iso: "CM" },
  { country: "Canada", code: "1", iso: "CA" },
  { country: "Cape Verde", code: "238", iso: "CV" },
  { country: "Cayman Islands", code: "1-345", iso: "KY" },
  { country: "Central African Republic", code: "236", iso: "CF" },
  { country: "Chad", code: "235", iso: "TD" },
  { country: "Chile", code: "56", iso: "CL" },
  { country: "China", code: "86", iso: "CN" },
  { country: "Christmas Island", code: "61", iso: "CX" },
  { country: "Cocos Islands", code: "61", iso: "CC" },
  { country: "Colombia", code: "57", iso: "CO" },
  { country: "Comoros", code: "269", iso: "KM" },
  { country: "Cook Islands", code: "682", iso: "CK" },
  { country: "Costa Rica", code: "506", iso: "CR" },
  { country: "Croatia", code: "385", iso: "HR" },
  { country: "Cuba", code: "53", iso: "CU" },
  { country: "Curacao", code: "599", iso: "CW" },
  { country: "Cyprus", code: "357", iso: "CY" },
  { country: "Czech Republic", code: "420", iso: "CZ" },
  { country: "Democratic Republic of the Congo", code: "243", iso: "CD" },
  { country: "Denmark", code: "45", iso: "DK" },
  { country: "Djibouti", code: "253", iso: "DJ" },
  { country: "Dominica", code: "1-767", iso: "DM" },
  { country: "Dominican Republic", code: "1-809, 1-829, 1-849", iso: "DO" },
  { country: "East Timor", code: "670", iso: "TL" },
  { country: "Ecuador", code: "593", iso: "EC" },
  { country: "Egypt", code: "20", iso: "EG" },
  { country: "El Salvador", code: "503", iso: "SV" },
  { country: "Equatorial Guinea", code: "240", iso: "GQ" },
  { country: "Eritrea", code: "291", iso: "ER" },
  { country: "Estonia", code: "372", iso: "EE" },
  { country: "Ethiopia", code: "251", iso: "ET" },
  { country: "Falkland Islands", code: "500", iso: "FK" },
  { country: "Faroe Islands", code: "298", iso: "FO" },
  { country: "Fiji", code: "679", iso: "FJ" },
  { country: "Finland", code: "358", iso: "FI" },
  { country: "France", code: "33", iso: "FR" },
  { country: "French Polynesia", code: "689", iso: "PF" },
  { country: "Gabon", code: "241", iso: "GA" },
  { country: "Gambia", code: "220", iso: "GM" },
  { country: "Georgia", code: "995", iso: "GE" },
  { country: "Germany", code: "49", iso: "DE" },
  { country: "Ghana", code: "233", iso: "GH" },
  { country: "Gibraltar", code: "350", iso: "GI" },
  { country: "Greece", code: "30", iso: "GR" },
  { country: "Greenland", code: "299", iso: "GL" },
  { country: "Grenada", code: "1-473", iso: "GD" },
  { country: "Guam", code: "1-671", iso: "GU" },
  { country: "Guatemala", code: "502", iso: "GT" },
  { country: "Guernsey", code: "44-1481", iso: "GG" },
  { country: "Guinea", code: "224", iso: "GN" },
  { country: "Guinea-Bissau", code: "245", iso: "GW" },
  { country: "Guyana", code: "592", iso: "GY" },
  { country: "Haiti", code: "509", iso: "HT" },
  { country: "Honduras", code: "504", iso: "HN" },
  { country: "Hong Kong", code: "852", iso: "HK" },
  { country: "Hungary", code: "36", iso: "HU" },
  { country: "Iceland", code: "354", iso: "IS" },
  { country: "India", code: "91", iso: "IN" },
  { country: "Indonesia", code: "62", iso: "ID" },
  { country: "Iran", code: "98", iso: "IR" },
  { country: "Iraq", code: "964", iso: "IQ" },
  { country: "Ireland", code: "353", iso: "IE" },
  { country: "Isle of Man", code: "44-1624", iso: "IM" },
  { country: "Israel", code: "972", iso: "IL" },
  { country: "Italy", code: "39", iso: "IT" },
  { country: "Ivory Coast", code: "225", iso: "CI" },
  { country: "Jamaica", code: "1-876", iso: "JM" },
  { country: "Japan", code: "81", iso: "JP" },
  { country: "Jersey", code: "44-1534", iso: "JE" },
  { country: "Jordan", code: "962", iso: "JO" },
  { country: "Kazakhstan", code: "7", iso: "KZ" },
  { country: "Kenya", code: "254", iso: "KE" },
  { country: "Kiribati", code: "686", iso: "KI" },
  { country: "Kosovo", code: "383", iso: "XK" },
  { country: "Kuwait", code: "965", iso: "KW" },
  { country: "Kyrgyzstan", code: "996", iso: "KG" },
  { country: "Laos", code: "856", iso: "LA" },
  { country: "Latvia", code: "371", iso: "LV" },
  { country: "Lebanon", code: "961", iso: "LB" },
  { country: "Lesotho", code: "266", iso: "LS" },
  { country: "Liberia", code: "231", iso: "LR" },
  { country: "Libya", code: "218", iso: "LY" },
  { country: "Liechtenstein", code: "423", iso: "LI" },
  { country: "Lithuania", code: "370", iso: "LT" },
  { country: "Luxembourg", code: "352", iso: "LU" },
  { country: "Macao", code: "853", iso: "MO" },
  { country: "Macedonia", code: "389", iso: "MK" },
  { country: "Madagascar", code: "261", iso: "MG" },
  { country: "Malawi", code: "265", iso: "MW" },
  { country: "Malaysia", code: "60", iso: "MY" },
  { country: "Maldives", code: "960", iso: "MV" },
  { country: "Mali", code: "223", iso: "ML" },
  { country: "Malta", code: "356", iso: "MT" },
  { country: "Marshall Islands", code: "692", iso: "MH" },
  { country: "Mauritania", code: "222", iso: "MR" },
  { country: "Mauritius", code: "230", iso: "MU" },
  { country: "Mayotte", code: "262", iso: "YT" },
  { country: "Mexico", code: "52", iso: "MX" },
  { country: "Micronesia", code: "691", iso: "FM" },
  { country: "Moldova", code: "373", iso: "MD" },
  { country: "Monaco", code: "377", iso: "MC" },
  { country: "Mongolia", code: "976", iso: "MN" },
  { country: "Montenegro", code: "382", iso: "ME" },
  { country: "Montserrat", code: "1-664", iso: "MS" },
  { country: "Morocco", code: "212", iso: "MA" },
  { country: "Mozambique", code: "258", iso: "MZ" },
  { country: "Myanmar", code: "95", iso: "MM" },
  { country: "Namibia", code: "264", iso: "NA" },
  { country: "Nauru", code: "674", iso: "NR" },
  { country: "Nepal", code: "977", iso: "NP" },
  { country: "Netherlands", code: "31", iso: "NL" },
  { country: "Netherlands Antilles", code: "599", iso: "AN" },
  { country: "New Caledonia", code: "687", iso: "NC" },
  { country: "New Zealand", code: "64", iso: "NZ" },
  { country: "Nicaragua", code: "505", iso: "NI" },
  { country: "Niger", code: "227", iso: "NE" },
  { country: "Niue", code: "683", iso: "NU" },
  { country: "North Korea", code: "850", iso: "KP" },
  { country: "Northern Mariana Islands", code: "1-670", iso: "MP" },
  { country: "Norway", code: "47", iso: "NO" },
  { country: "Oman", code: "968", iso: "OM" },
  { country: "Pakistan", code: "92", iso: "PK" },
  { country: "Palau", code: "680", iso: "PW" },
  { country: "Palestine", code: "970", iso: "PS" },
  { country: "Panama", code: "507", iso: "PA" },
  { country: "Papua New Guinea", code: "675", iso: "PG" },
  { country: "Paraguay", code: "595", iso: "PY" },
  { country: "Peru", code: "51", iso: "PE" },
  { country: "Philippines", code: "63", iso: "PH" },
  { country: "Pitcairn", code: "64", iso: "PN" },
  { country: "Poland", code: "48", iso: "PL" },
  { country: "Portugal", code: "351", iso: "PT" },
  { country: "Puerto Rico", code: "1-787, 1-939", iso: "PR" },
  { country: "Qatar", code: "974", iso: "QA" },
  { country: "Republic of the Congo", code: "242", iso: "CG" },
  { country: "Reunion", code: "262", iso: "RE" },
  { country: "Romania", code: "40", iso: "RO" },
  { country: "Russia", code: "7", iso: "RU" },
  { country: "Rwanda", code: "250", iso: "RW" },
  { country: "Saint Barthelemy", code: "590", iso: "BL" },
  { country: "Saint Helena", code: "290", iso: "SH" },
  { country: "Saint Kitts and Nevis", code: "1-869", iso: "KN" },
  { country: "Saint Lucia", code: "1-758", iso: "LC" },
  { country: "Saint Martin", code: "590", iso: "MF" },
  { country: "Saint Pierre and Miquelon", code: "508", iso: "PM" },
  { country: "Saint Vincent and the Grenadines", code: "1-784", iso: "VC" },
  { country: "Samoa", code: "685", iso: "WS" },
  { country: "San Marino", code: "378", iso: "SM" },
  { country: "Sao Tome and Principe", code: "239", iso: "ST" },
  { country: "Saudi Arabia", code: "966", iso: "SA" },
  { country: "Senegal", code: "221", iso: "SN" },
  { country: "Serbia", code: "381", iso: "RS" },
  { country: "Seychelles", code: "248", iso: "SC" },
  { country: "Sierra Leone", code: "232", iso: "SL" },
  { country: "Singapore", code: "65", iso: "SG" },
  { country: "Sint Maarten", code: "1-721", iso: "SX" },
  { country: "Slovakia", code: "421", iso: "SK" },
  { country: "Slovenia", code: "386", iso: "SI" },
  { country: "Solomon Islands", code: "677", iso: "SB" },
  { country: "Somalia", code: "252", iso: "SO" },
  { country: "South Africa", code: "27", iso: "ZA" },
  { country: "South Korea", code: "82", iso: "KR" },
  { country: "South Sudan", code: "211", iso: "SS" },
  { country: "Spain", code: "34", iso: "ES" },
  { country: "Sri Lanka", code: "94", iso: "LK" },
  { country: "Sudan", code: "249", iso: "SD" },
  { country: "Suriname", code: "597", iso: "SR" },
  { country: "Svalbard and Jan Mayen", code: "47", iso: "SJ" },
  { country: "Swaziland", code: "268", iso: "SZ" },
  { country: "Sweden", code: "46", iso: "SE" },
  { country: "Switzerland", code: "41", iso: "CH" },
  { country: "Syria", code: "963", iso: "SY" },
  { country: "Taiwan", code: "886", iso: "TW" },
  { country: "Tajikistan", code: "992", iso: "TJ" },
  { country: "Tanzania", code: "255", iso: "TZ" },
  { country: "Thailand", code: "66", iso: "TH" },
  { country: "Togo", code: "228", iso: "TG" },
  { country: "Tokelau", code: "690", iso: "TK" },
  { country: "Tonga", code: "676", iso: "TO" },
  { country: "Trinidad and Tobago", code: "1-868", iso: "TT" },
  { country: "Tunisia", code: "216", iso: "TN" },
  { country: "Turkey", code: "90", iso: "TR" },
  { country: "Turkmenistan", code: "993", iso: "TM" },
  { country: "Turks and Caicos Islands", code: "1-649", iso: "TC" },
  { country: "Tuvalu", code: "688", iso: "TV" },
  { country: "U.S. Virgin Islands", code: "1-340", iso: "VI" },
  { country: "Uganda", code: "256", iso: "UG" },
  { country: "Ukraine", code: "380", iso: "UA" },
  { country: "United Arab Emirates", code: "971", iso: "AE" },
  { country: "United Kingdom", code: "44", iso: "GB" },
  { country: "United States", code: "1", iso: "US" },
  { country: "Uruguay", code: "598", iso: "UY" },
  { country: "Uzbekistan", code: "998", iso: "UZ" },
  { country: "Vanuatu", code: "678", iso: "VU" },
  { country: "Vatican", code: "379", iso: "VA" },
  { country: "Venezuela", code: "58", iso: "VE" },
  { country: "Vietnam", code: "84", iso: "VN" },
  { country: "Wallis and Futuna", code: "681", iso: "WF" },
  { country: "Western Sahara", code: "212", iso: "EH" },
  { country: "Yemen", code: "967", iso: "YE" },
  { country: "Zambia", code: "260", iso: "ZM" },
  { country: "Zimbabwe", code: "263", iso: "ZW" },
];

export const careerspeakers = [
  {
    speakerImg: speaker1,
    speakerName: "Olabanji Ewenla",
    speakerPosition: "Founder & CEO",
    speakerBio:
      "Gain exclusive insights from industry leaders as they share their career journeys and product management wisdom.",
  },
  {
    speakerImg: speaker2,
    speakerName: "Olabanji Ewenla",
    speakerPosition: "Founder & CEO",
    speakerBio:
      "Gain exclusive insights from industry leaders as they share their career journeys and product management wisdom.",
  },
  {
    speakerImg: speaker3,
    speakerName: "Olabanji Ewenla",
    speakerPosition: "Founder & CEO",
    speakerBio:
      "Gain exclusive insights from industry leaders as they share their career journeys and product management wisdom.",
  },
  {
    speakerImg: speaker4,
    speakerName: "Olabanji Ewenla",
    speakerPosition: "Founder & CEO",
    speakerBio:
      "Gain exclusive insights from industry leaders as they share their career journeys and product management wisdom.",
  },
];

export const newsContent = [
  {
    newsImg: newsImg1,
    newsTopic:
      "Enoverlab Expands Footprint with New Learning Center in Awka, Anambra",
    newsLink:
      "https://www.thisdaylive.com/index.php/2024/03/08/enoverlab-expands-footprint-with-new-learning-center-in-awka-anambra/#google_vignette",
  },
  {
    newsImg: newsImg2,
    newsTopic:
      "Earning £7K In Nigeria Is More Appealing Than In The UK - Olabanji Ewenla",
    newsLink: "https://www.youtube.com/watch?v=SSxBMumUle8",
  },
  {
    newsImg: newsImg3,
    newsTopic: "Charting your paths in a digital world",
    newsLink:
      "www.linkedin.com/feed/update/urn:li:activity:7228830982689157120/",
  },
  {
    newsImg: newsImg4,
    newsTopic:
      "Enoverlab Marks Four Years of Transforming Africa's Tech Talent Landscape",
    newsLink:
      "https://www.thisdaylive.com/2025/09/05/enoverlab-marks-four-years-of-transforming-africas-tech-talent-landscape/",
  },
];
